/**
 * Created by ganlu on 25/09/2016.
 */
export default () => {
    return function (scope, elem, attrs) {
      elem.on('click.close', '.close', function (e) {
        e.preventDefault()
        e.stopPropagation();
        elem.removeClass('active');
        $('body').removeClass('no-scroll');
        scope.$eval(attrs.onClose)&&scope.$eval(attrs.onClose).call(scope.$ctrl)
      });
    }
};



// WEBPACK FOOTER //
// ./src/app/common/modal/modal-control.directive.js